

import React, { useState, useEffect } from "react";
import { Card, Button, Dropdown, Menu, Modal, Spin, Collapse, Typography, message, Tabs } from "antd";
import { FileTextOutlined, FileAddOutlined, PaperClipOutlined, BookOutlined, EllipsisOutlined, MoreOutlined, DeleteOutlined, EditOutlined, EyeOutlined, PlusOutlined, ReadOutlined, DownOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import courseService from "../../services/course.service"; // Service API
import authHeader from "../../services/auth-header"; // Auth header for Bearer Token
import CourseCreateForm from "./CourseCreateForm";
import AddSubjectForm from "./AddSubjectForm";
// import API_BASE from "../config/apiConfig";
import QuizManager from "./QuizManager";

import API_BASE from "../../config/apiConfig";
import Title from "antd/es/skeleton/Title";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";


const API_BASE_URL = `${API_BASE}/images/proxy`; // Crée une URL dynamique basée sur la configuration


const ModeratorCourses = () => {
    const [refresh, setRefresh] = useState(false);

    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [isAddingSubject, setIsAddingSubject] = useState(false);
    const imageCache = {}; // Cache des images pour éviter les boucles infinies
    const moderatorId = 1; // Remplacez par l'ID du modérateur connecté
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const response = await courseService.getCoursesByModerator(1);

                const updatedCourses = await Promise.all(
                    response.map(async (course) => {
                        if (course.image && !imageCache[course.image]) {
                            const imageUrl = await fetchImage(course.image);
                            imageCache[course.image] = imageUrl; // Mise en cache de l'image
                            return { ...course, imageUrl };
                        } else {
                            return { ...course, imageUrl: imageCache[course.image] || "/default-image.png" };
                        }
                    })
                );
                setCourses(updatedCourses);
            } catch (error) {
                console.error("Erreur lors du chargement des cours :", error);
            } finally {
                setLoading(false);
            }
        };
        fetchCourses();
    }, [moderatorId]);


    const onDragEnd = (result) => {
        console.log("Drag & Drop event:", result);

        if (!result.destination) return; // Vérifie si l'élément a été déplacé

        const { source, destination, type } = result;

        if (type === "group") {
            console.log("Réorganisation des groupes");

            const items = Array.from(Object.entries(groupedSubjects));
            const [reorderedItem] = items.splice(source.index, 1);
            items.splice(destination.index, 0, reorderedItem);

            setGroupedSubjects(Object.fromEntries(items));
        } else if (type === "subject") {
            console.log("Réorganisation des sujets");

            const groupName = source.droppableId;
            const subjects = Array.from(groupedSubjects[groupName]);

            const [movedSubject] = subjects.splice(source.index, 1);
            subjects.splice(destination.index, 0, movedSubject);

            setGroupedSubjects((prev) => ({
                ...prev,
                [groupName]: subjects,
            }));
        }

        // 🚀 Forcer le re-rendu
        setRefresh((prev) => !prev);
    };




    const fetchImage = async (imageUrl) => {
        try {
            const response = await fetch(
                // `https://glistening-dedication-production.up.railway.app/api/images/proxy?url=${encodeURIComponent(imageUrl)}`,
                // `http://localhost:8080/api/images/proxy?url=${encodeURIComponent(imageUrl)}`,
                `${API_BASE_URL}?url=${encodeURIComponent(imageUrl)}`,

                {
                    headers: authHeader(),
                }
            );
            if (!response.ok) {
                throw new Error("Erreur lors de la récupération de l'image");
            }
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        } catch (error) {
            console.error("Erreur lors de la récupération de l'image :", error);
            return "/default-image.png";
        }
    };

    const handleEditCourse = (course) => {
        setSelectedCourse(course);
        setIsEditing(true);
    };

    // const handleAddSubject = (course) => {
    //     setSelectedCourse(course);
    //     setIsAddingSubject(true);
    // };

    const handleAddSubject = (course) => {
        setSelectedCourse(course);
        setSelectedSubject(null); // Réinitialise le sujet sélectionné
        setIsAddingSubject(true);
    };


    const [selectedCourseSubjects, setSelectedCourseSubjects] = useState([]);
    const [isSubjectsModalVisible, setIsSubjectsModalVisible] = useState(false);
    const [groupedSubjects, setGroupedSubjects] = useState({});

    useEffect(() => {
        console.log("Grouped Subjects Updated (Rendering):", groupedSubjects);
    }, [groupedSubjects]);



    const handleShowSubjects = async (course) => {
        setSelectedCourse(course);
        console.log("Cours sélectionné :", course);

        try {
            const response = await courseService.getSubjectsByCourse(course.id);
            console.log("Sujets récupérés :", response);
            setSelectedCourseSubjects(response);

            // 🌟 Grouper les sujets par Groupe → Sujet → Sous-sujet
            const grouped = response.reduce((acc, subject) => {
                if (!acc[subject.group_name]) acc[subject.group_name] = {}; // Groupe

                if (!acc[subject.group_name][subject.title]) {
                    acc[subject.group_name][subject.title] = []; // Sujet
                }

                acc[subject.group_name][subject.title].push(subject); // Ajouter le sous-sujet
                return acc;
            }, {});

            setGroupedSubjects(grouped);
            setIsSubjectsModalVisible(true);
        } catch (error) {
            console.error("Erreur lors de la récupération des sujets :", error);
        }
    };


    const [selectedSubject, setSelectedSubject] = useState(null);
    const [isEditingSubject, setIsEditingSubject] = useState(false);

    // const handleEditSubject = (subject) => {
    //     setSelectedSubject(subject);
    //     setIsEditingSubject(true);
    // };

    const handleEditSubject = (subject) => {
        console.log("Sujet sélectionné pour modification :", subject); // Debug
        console.log("Course ID sélectionné :", selectedCourse?.id); // Debug pour vérifier le cours

        setSelectedSubject({
            ...subject,
            courseId: subject.courseId || selectedCourse?.id, // Priorité à courseId sinon on prend celui du cours sélectionné
        });
        setIsEditingSubject(true);
    };


    const handleDeleteSubject = (subjectId) => {
        Modal.confirm({
            title: "Confirmation",
            content: "Êtes-vous sûr de vouloir supprimer ce sujet ? Cette action est irréversible.",
            okText: "Oui, supprimer",
            okType: "danger",
            cancelText: "Annuler",
            onOk: async () => {
                setLoading(true); // Affichage du Spin pendant la suppression
                try {
                    await courseService.deleteSubject(subjectId);
                    message.success("Sujet supprimé avec succès.");

                    // Actualisation de la liste des sujets
                    const updatedSubjects = selectedCourseSubjects.filter(subject => subject.id !== subjectId);
                    setSelectedCourseSubjects(updatedSubjects);

                    // Si aucun sujet ne reste, fermer le Modal
                    if (updatedSubjects.length === 0) {
                        setTimeout(() => {
                            setIsSubjectsModalVisible(false);
                        }, 800); // Fermeture du Modal après 800 ms
                    } else {
                        // Si des sujets restent, fermer le Modal après le message de succès
                        setTimeout(() => {
                            setIsSubjectsModalVisible(false);
                        }, 800); // Fermeture du Modal après 800 ms
                    }
                } catch (error) {
                    message.error("Erreur lors de la suppression du sujet.");
                } finally {
                    setLoading(false); // Cacher le Spin après l'opération
                }
            }
        });
    };





    if (loading) {
        return <Spin size="large" style={{ display: "block", margin: "auto" }} />;
    }

    const handleDeleteCourse = (courseId) => {
        Modal.confirm({
            title: "Confirmation",
            content: "Êtes-vous sûr de vouloir supprimer ce cours ? Cette action est irréversible.",
            okText: "Oui, supprimer",
            okType: "danger",
            cancelText: "Annuler",
            onOk: async () => {
                setLoading(true);
                try {
                    await courseService.deleteCourse(courseId);
                    message.success("Cours supprimé avec succès !");
                    setCourses((prevCourses) => prevCourses.filter(course => course.id !== courseId));
                } catch (error) {
                    message.error("Erreur lors de la suppression du cours.");
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    const getCourseActions = (course) => (
        <Menu>
            <Menu.Item key="1" icon={<EditOutlined />} onClick={() => handleEditCourse(course)}>
                Modifier le cours
            </Menu.Item>
            <Menu.Item key="2" icon={<PlusOutlined />} onClick={() => navigate(`/mod/course/${course.id}/subjects`)}>
                Ajouter un élément
            </Menu.Item>
            <Menu.Item key="3" icon={<EyeOutlined />} onClick={() => navigate(`/mod/course/${course.id}/view`)}>
                Voir les sujets
            </Menu.Item>
            <Menu.Item key="4" icon={<DeleteOutlined />} onClick={() => handleDeleteCourse(course.id)} danger>
                Supprimer le cours
            </Menu.Item>
        </Menu>
    );

    if (loading) {
        return <Spin size="large" className="flex justify-center items-center h-screen" />;
    }
    const { Title, Text } = Typography;
    const { TabPane } = Tabs;

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                }}
            >
                <h2 style={{ margin: "0", fontSize: "24px", fontWeight: "bold" }}>Mes Cours</h2>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => navigate("/mod/create-course")}
                    style={{ backgroundColor: "#4A90E2", borderColor: "#4A90E2" }}
                >
                    Ajouter un cours
                </Button>
            </div>

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                    gap: "20px",
                }}
            >
                {courses.map((course) => (
                    <Card
                        key={course.id}
                        hoverable
                        cover={
                            <img
                                alt={course.title}
                                src={course.imageUrl || "/default-image.png"}
                                style={{
                                    height: "180px",
                                    objectFit: "cover",
                                    borderRadius: "8px 8px 0 0",
                                }}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "/default-image.png"; // Image par défaut
                                }}
                            />
                        }
                        style={{
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            overflow: "hidden",
                            position: "relative",
                        }}
                    >
                        <div style={{ padding: "15px" }}>
                            {/* <h3 style={{ fontSize: "18px", fontWeight: "bold", margin: "0 0 10px 0" }}>
                                {course.title}
                            </h3> */}
                            <Title level={2} style={{ marginBottom: 10, fontSize: "13px" }}>
                                {course.title}
                            </Title>
                            <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                                <strong>Leçons :</strong> {course.lessons || "0"} | <strong>Prix :</strong> {course.latest_price || "0"}
                            </p>
                            <p
                                style={{
                                    color: course.price ? "#1890ff" : "#52c41a",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    margin: "0",
                                }}
                            >
                                {course.price || "Gratuit"}
                            </p>

                            {/* <Button
                                type="primary"
                                block
                                style={{ marginTop: "15px" }}
                                onClick={() => handleAddSubject(course)}
                            >
                                Ajouter un sujet encien
                            </Button> */}
                            {/* <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
                                <Button
                                    type="default"
                                    block
                                    onClick={() => handleEditCourse(course)}
                                >
                                    Modifier le cours
                                </Button>
                                <Button
                                    type="primary"
                                    block
                                    onClick={() => handleAddSubject(course)}
                                >
                                    Ajouter un sujet
                                </Button>

                            </div>
                            <Button type="default" block onClick={() => handleShowSubjects(course)}>
                                Afficher les sujets
                            </Button> */}
                            <Dropdown
                                overlay={
                                    <Menu>
                                        <Menu.Item key="1" icon={<EditOutlined />} onClick={() => handleEditCourse(course)}>
                                            Modifier le cours
                                        </Menu.Item>
                                        <Menu.Item key="2" icon={<PlusOutlined />} onClick={() => handleAddSubject(course)}>
                                            Ajouter un élément
                                        </Menu.Item>
                                        <Menu.Item key="3" icon={<EyeOutlined />} onClick={() => handleShowSubjects(course)}>
                                            Voir les sujets
                                        </Menu.Item>
                                        <Menu.Item key="4" icon={<DeleteOutlined />} onClick={() => handleDeleteCourse(course.id)} danger>
                                            Supprimer le cours
                                        </Menu.Item>
                                    </Menu>
                                }
                                trigger={["click"]}
                            >
                                <Button type="primary" block>
                                    Actions <DownOutlined />
                                </Button>
                            </Dropdown>




                        </div>
                    </Card>
                ))}
            </div>
            <Modal
                visible={isEditingSubject}
                title="Modifier le sujet"
                footer={null}
                width="50%"
                onCancel={() => setIsEditingSubject(false)}
            >
                <AddSubjectForm
                    subject={selectedSubject}
                    onClose={() => setIsEditingSubject(false)}
                />
            </Modal>


            {/* Modal pour modifier le cours */}
            {/* <Modal
                visible={isEditing}
                title="Modifier le cours"
                footer={null}
                width="80%"
                style={{ top: 20 }}
                onCancel={() => setIsEditing(false)}
            >
                <CourseCreateForm btnText="Modifier le cours" initialData={selectedCourse} />
            </Modal> */}




            <Modal
                visible={isEditing}
                title={`Modifier le cours : ${selectedCourse?.title}`}
                footer={null}
                width="80%"
                style={{ top: 20 }}
                onCancel={() => setIsEditing(false)}
            >
                <CourseCreateForm
                    btnText="Modifier le cours"
                    initialData={selectedCourse} // Passe les données sélectionnées au formulaire
                    onClose={() => {
                        setIsEditing(false);
                        // refreshCourses();
                    }}
                />
            </Modal>



            {/* <Modal
                open={isAddingSubject}
                title={`Ajouter un sujet au cours : ${selectedCourse?.title}`}
                footer={null}
                width="50%"
                onCancel={() => setIsAddingSubject(false)}
            >
                <AddSubjectForm
                    key={selectedCourse?.id} // Force le re-render pour vider les champs
                    courseId={selectedCourse?.id}
                    subject={null} // On force l'absence de sujet pour vider les champs
                    onClose={() => setIsAddingSubject(false)}
                />
            </Modal> */}


            <Modal
                open={isAddingSubject}
                title={`Ajouter des éléments au cours : ${selectedCourse?.title}`}
                footer={null}
                width="70%"
                onCancel={() => setIsAddingSubject(false)}
                style={{ top: 20 }}
            >
                <Tabs defaultActiveKey="1" tabPosition="top" type="line">
                    <TabPane
                        tab={
                            <span>
                                <FileTextOutlined style={{ color: "#1890ff" }} /> Sujet
                            </span>
                        }
                        key="1"
                    >
                        <Card size="small" title={`Ajouter un sujet au cours : ${selectedCourse?.title}`}
                        >
                            <AddSubjectForm
                                key={selectedCourse?.id}
                                courseId={selectedCourse?.id}
                                subject={null}
                                onClose={() => setIsAddingSubject(false)}
                            />
                        </Card>

                    </TabPane>

                    <TabPane
                        tab={
                            <span>
                                <FileAddOutlined style={{ color: "#52c41a" }} /> Évaluation / Contrôle
                            </span>
                        }
                        key="2"
                    >
                        <p>Ici, tu pourras intégrer le composant `QuizManager` ou un autre formulaire d'évaluation.</p>
                        <QuizManager subjectId={selectedSubject?.id} />
                    </TabPane>

                    <TabPane
                        tab={
                            <span>
                                <PaperClipOutlined style={{ color: "#fa8c16" }} /> Pièce jointe
                            </span>
                        }
                        key="3"
                    >
                        <p>Uploader ici des fichiers avec `Upload` d'Ant Design.</p>
                    </TabPane>

                    <TabPane
                        tab={
                            <span>
                                <BookOutlined style={{ color: "#722ed1" }} /> Ressource
                            </span>
                        }
                        key="4"
                    >
                        <p>Ajouter des liens ou documents complémentaires (liens vidéos, docs...)</p>
                    </TabPane>
                </Tabs>
            </Modal>


            <Modal
                visible={isEditingSubject}
                title={`Modifier le sujet : ${selectedSubject?.title}`}
                footer={null}
                width="50%"
                onCancel={() => setIsEditingSubject(false)}
            >
                {selectedSubject && (
                    <AddSubjectForm
                        subject={selectedSubject}  // On passe bien le sujet ici
                        onClose={() => setIsEditingSubject(false)}
                    />
                )}
            </Modal>


            {/* <Modal
                open={isSubjectsModalVisible}
                title={`Liste des sujets : Cours numéro ${selectedCourse?.id || 'Non défini'}`}
                footer={null}
                width="60%"
                onCancel={() => setIsSubjectsModalVisible(false)}
            >
                {loading ? (
                    <Spin size="large" style={{ display: "block", margin: "auto" }} />
                ) : (
                    Object.keys(groupedSubjects).length > 0 ? (
                        <Collapse accordion>
                            {Object.entries(groupedSubjects).map(([groupName, subSubjects]) => (
                                <Collapse.Panel header={<b>{groupName}</b>} key={groupName}>
                                    <Collapse accordion>
                                        {Object.entries(subSubjects).map(([subTitle, subjects]) => (
                                            <Collapse.Panel header={<span style={{ fontWeight: "bold", color: "#1890ff" }}>{subTitle || "Sans sous-titre"}</span>} key={subTitle}>
                                                <ul style={{ listStyleType: "none", padding: 0 }}>
                                                    {subjects.map((subject) => (
                                                        <li key={subject.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: "1px solid #ddd" }}>
                                                            <span>{subject.title}</span>
                                                            <div style={{ display: "flex", gap: "10px" }}>
                                                                <Button type="link" onClick={() => handleEditSubject(subject)}>Modifier</Button>
                                                                <Button type="link" danger onClick={() => handleDeleteSubject(subject.id)}>Supprimer</Button>
                                                                <QuizManager subjectId={subject.id} />
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </Collapse.Panel>
                                        ))}
                                    </Collapse>
                                </Collapse.Panel>
                            ))}
                        </Collapse>
                    ) : (
                        <p>Aucun sujet disponible pour ce cours.</p>
                    )
                )}
            </Modal> */}


            <Modal
                open={isSubjectsModalVisible}
                title={`Liste des sujets : Cours numéro ${selectedCourse?.id || 'Non défini'}`}
                footer={null}
                width="60%"
                onCancel={() => setIsSubjectsModalVisible(false)}
            >
                {loading ? (
                    <Spin size="large" style={{ display: "block", margin: "auto" }} />
                ) : (
                    Object.keys(groupedSubjects).length > 0 ? (
                        <Collapse accordion>
                            {Object.entries(groupedSubjects).map(([groupName, subjects]) => (
                                <Collapse.Panel header={<b>{groupName}</b>} key={groupName}>
                                    <Collapse accordion>
                                        {Object.entries(subjects).map(([subjectTitle, subSubjects]) => (
                                            <Collapse.Panel header={<span style={{ fontWeight: "bold", color: "#1890ff" }}>{subjectTitle}</span>} key={subjectTitle}>
                                                <ul style={{ listStyleType: "none", padding: 0 }}>
                                                    {subSubjects.map((subject) => (
                                                        <li key={subject.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: "1px solid #ddd" }}>
                                                            <span>{subject.subTitle || "Sans sous-titre"}</span>
                                                            <div style={{ display: "flex", gap: "10px" }}>
                                                                <Button type="link" onClick={() => handleEditSubject(subject)}>Modifier</Button>
                                                                <Button type="link" danger onClick={() => handleDeleteSubject(subject.id)}>Supprimer</Button>
                                                                <QuizManager subjectId={subject.id} />
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </Collapse.Panel>
                                        ))}
                                    </Collapse>
                                </Collapse.Panel>
                            ))}
                        </Collapse>
                    ) : (
                        <p>Aucun sujet disponible pour ce cours.</p>
                    )
                )}
            </Modal>



        </div>
    );





};

export default ModeratorCourses;


